/*const verified_svg = `
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.7925 9.94182C23.8193 9.73882 23.8333 9.53582 23.8333 9.33398C23.8333 6.55848 21.3332 4.33132 18.5588 4.70815C17.7503 3.26965 16.2103 2.33398 14.5 2.33398C12.7897 2.33398 11.2497 3.26965 10.4412 4.70815C7.66101 4.33132 5.16668 6.55848 5.16668 9.33398C5.16668 9.53582 5.18068 9.73882 5.20751 9.94182C3.76901 10.7515 2.83334 12.2915 2.83334 14.0007C2.83334 15.7098 3.76901 17.2498 5.20751 18.0595C5.18059 18.261 5.16695 18.464 5.16668 18.6673C5.16668 21.4428 7.66101 23.6642 10.4412 23.2932C11.2497 24.7317 12.7897 25.6673 14.5 25.6673C16.2103 25.6673 17.7503 24.7317 18.5588 23.2932C21.3332 23.6642 23.8333 21.4428 23.8333 18.6673C23.8333 18.4655 23.8193 18.2625 23.7925 18.0595C25.231 17.2498 26.1667 15.7098 26.1667 14.0007C26.1667 12.2915 25.231 10.7515 23.7925 9.94182ZM13.2808 19.1527L9.00268 14.8197L10.664 13.1817L13.2972 15.8487L18.3453 10.839L19.988 12.4957L13.2808 19.1527Z" fill="#111827"/>
    </svg>
`;
    const rated_svg = `
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.4883 2.33398C8.04831 2.33398 2.83331 7.56065 2.83331 14.0007C2.83331 20.4407 8.04831 25.6673 14.4883 25.6673C20.94 25.6673 26.1666 20.4407 26.1666 14.0007C26.1666 7.56065 20.94 2.33398 14.4883 2.33398ZM19.435 21.0007L14.5 18.0257L9.56498 21.0007L10.8716 15.389L6.51998 11.6207L12.26 11.1307L14.5 5.83398L16.74 11.119L22.48 11.609L18.1283 15.3773L19.435 21.0007Z" fill="#111827"/>
    </svg>
    `;
    const free_shipping_svg = `
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.04718 5.24606C1.04718 4.13073 1.95135 3.22656 3.06668 3.22656H16.5335C17.6488 3.22656 18.5542 4.13073 18.5542 5.24606V7.2679H20.6868C21.4014 7.26692 22.0871 7.54976 22.5932 8.05423L25.847 11.3069C26.3515 11.813 26.6343 12.4987 26.6333 13.2132V18.0409C26.9906 18.0409 27.3332 18.1828 27.5858 18.4354C27.8384 18.688 27.9803 19.0306 27.9803 19.3878C27.9803 19.745 27.8384 20.0876 27.5858 20.3402C27.3332 20.5928 26.9906 20.7347 26.6333 20.7347H25.287C25.2617 21.7894 24.8249 22.7924 24.07 23.5294C23.315 24.2664 22.3019 24.679 21.2468 24.679C20.1918 24.679 19.1786 24.2664 18.4237 23.5294C17.6688 22.7924 17.232 21.7894 17.2067 20.7347H11.8202C11.7948 21.7894 11.358 22.7924 10.6031 23.5294C9.84821 24.2664 8.83503 24.679 7.78001 24.679C6.725 24.679 5.71181 24.2664 4.9569 23.5294C4.20198 22.7924 3.76519 21.7894 3.73985 20.7347H3.06668C2.53097 20.7341 2.01743 20.5208 1.63895 20.1417C1.26047 19.7625 1.04804 19.2486 1.04835 18.7129L1.04718 5.24606ZM18.5542 13.9996H23.9407V13.2121L20.6868 9.9594H18.5542V13.9996ZM7.78001 22.7531C8.31577 22.7531 8.82959 22.5402 9.20843 22.1614C9.58727 21.7826 9.8001 21.2687 9.8001 20.733C9.8001 20.1972 9.58727 19.6834 9.20843 19.3046C8.82959 18.9257 8.31577 18.7129 7.78001 18.7129C7.24425 18.7129 6.73044 18.9257 6.3516 19.3046C5.97276 19.6834 5.75993 20.1972 5.75993 20.733C5.75993 21.2687 5.97276 21.7826 6.3516 22.1614C6.73044 22.5402 7.24425 22.7531 7.78001 22.7531ZM23.2675 20.7324C23.2675 20.1966 23.0547 19.6828 22.6758 19.304C22.297 18.9251 21.7832 18.7123 21.2474 18.7123C20.7117 18.7123 20.1979 18.9251 19.819 19.304C19.4402 19.6828 19.2273 20.1966 19.2273 20.7324C19.2273 21.2682 19.4402 21.782 19.819 22.1608C20.1979 22.5396 20.7117 22.7525 21.2474 22.7525C21.7832 22.7525 22.297 22.5396 22.6758 22.1608C23.0547 21.782 23.2675 21.2682 23.2675 20.7324ZM11.8622 7.22356C11.6716 7.04116 11.4171 6.94064 11.1533 6.94354C10.8896 6.94643 10.6374 7.05251 10.4508 7.23905C10.2643 7.4256 10.1582 7.67777 10.1553 7.94157C10.1524 8.20536 10.2529 8.4598 10.4353 8.6504L12.0768 10.2919H5.08735C4.95458 10.2916 4.82306 10.3175 4.70034 10.3682C4.57763 10.4188 4.46613 10.4932 4.37225 10.5871C4.27837 10.681 4.20396 10.7925 4.15329 10.9152C4.10263 11.0379 4.07671 11.1695 4.07701 11.3022C4.07701 11.8622 4.52735 12.3114 5.08735 12.3114H12.0768L10.4353 13.9529C10.2623 14.1452 10.1697 14.3966 10.1765 14.6553C10.1833 14.9139 10.2891 15.1601 10.4721 15.343C10.655 15.5259 10.9012 15.6317 11.1598 15.6386C11.4184 15.6454 11.6698 15.5528 11.8622 15.3797L15.2292 12.0127C15.3231 11.9193 15.3976 11.8082 15.4484 11.6859C15.4993 11.5635 15.5255 11.4324 15.5255 11.2999C15.5255 11.1674 15.4993 11.0362 15.4484 10.9139C15.3976 10.7916 15.3231 10.6805 15.2292 10.5871L11.8622 7.22356Z" fill="#111827"/>
    </svg>
`;

const style = `
    <style>
    .rebuy-cart__flyout-installments {
        display: none !important;
    }
    .cart-bottom-usp {
        display: grid;
        grid-template-columns: 2fr auto 3fr auto 2fr;
        gap: 10px;
        padding: 12px;
    }
    .cart-usp-item {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #111827;
        font-weight: 700;
        font-size: 11px;
        line-height: 12px;
    }
    .cart-usp-separator {
        width: 1px;
        height: 100%;
        background-color: #111827;
        display: block !important;
    }
    .cart-usp-item svg {
        flex-shrink: 0;
    }
    .cart-top-usp {
        background: #369f57 !important;
        padding: 12px 20px !important;
        font-size: 14px !important;
        line-height: 16px !important;
        font-weight: 800 !important;
        text-align: center !important;
        color: #fff !important;
    }
    .product-rating {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 4px;
    }
    .product-rating span {
        font-size: 12px;
        line-height: 12px;
        text-transform: uppercase;
        color: #0a0909;
    }
    .rebuy-product-block .rebuy-button {
        margin-top: 10px !important;
    }
    </style>
    `;

    const update_bundle = (item) => {
        const product_info = item.querySelector('.rebuy-product-info');
        const product_actions = item.querySelector('.rebuy-product-actions');
        if (product_info && product_actions) {
            product_actions.classList.add('rebuy-product-actions-updated');
            product_actions.querySelector('button span').innerHTML = 'Add to Cart';
            product_info.insertAdjacentElement('beforeend', product_actions);
        }
    };

    const add_bottom_usp_html = `
    <div class="cart-bottom-usp">
        <div class="cart-usp-item">
            ${verified_svg}
            <strong>Grounding Guarantee</strong>
        </div>
        <div class="cart-usp-separator"></div>
        <div class="cart-usp-item">
            ${rated_svg}
            <strong>Rated 4.9, 50000+ Happy Customers</strong>
        </div>
        <div class="cart-usp-separator"></div>
        <div class="cart-usp-item">
            ${free_shipping_svg}
            <strong>Fast & Free Shipping</strong>
        </div>
    </div>
`;

    const styleInterval = setInterval(() => {
        try {
            const head = document.querySelector('head');
            if (head) {
                head.insertAdjacentHTML('beforeend', style);
                clearInterval(styleInterval);
            }
        } catch (error) {
            console.error('A/B test style error', error);
        }
    }, 10);

    const interval = setInterval(() => {
        try {
            const cart_progress_bar = document.querySelector(
                '.rebuy-cart__progress-bar-container.above'
            );
            const checkout_btn = document.querySelector(
                '.rebuy-cart__flyout-actions button.rebuy-button.rebuy-cart__checkout-button.block'
            );
            const custom_info_section = document.querySelector(
                '.rebuy-cart__flyout-actions'
            );
            const bundle_save_items = document.querySelectorAll(
                '.rebuy-product-grid .rebuy-product-block '
            );
            if (
                cart_progress_bar &&
                checkout_btn &&
                custom_info_section &&
                bundle_save_items.length > 0 &&
                !document.querySelector('.cart-top-usp')
            ) {
                //custom_info_section.insertAdjacentHTML('afterend', add_bottom_usp_html);
                //cart_progress_bar.innerHTML = `Now offering Free Shipping on all orders!`;
                //cart_progress_bar.classList.add('cart-top-usp');
                checkout_btn.innerText = 'SECURE CHECKOUT';
                bundle_save_items.forEach((item) => {
                    update_bundle(item);
                });
                clearInterval(interval);
            }
        } catch (error) {
            console.error('A/B test js error', error);
        }
    }, 10);

    */

const mattress_links = ['/products/onearthing-mattress-cover'];

const verified_icon = `
<svg class="ab-svg" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.2927 9.94182C23.3195 9.73882 23.3335 9.53582 23.3335 9.33398C23.3335 6.55848 20.8333 4.33132 18.059 4.70815C17.2505 3.26965 15.7105 2.33398 14.0002 2.33398C12.2898 2.33398 10.7498 3.26965 9.94133 4.70815C7.16116 4.33132 4.66683 6.55848 4.66683 9.33398C4.66683 9.53582 4.68083 9.73882 4.70766 9.94182C3.26916 10.7515 2.3335 12.2915 2.3335 14.0007C2.3335 15.7098 3.26916 17.2498 4.70766 18.0595C4.68075 18.261 4.66711 18.464 4.66683 18.6673C4.66683 21.4428 7.16116 23.6642 9.94133 23.2932C10.7498 24.7317 12.2898 25.6673 14.0002 25.6673C15.7105 25.6673 17.2505 24.7317 18.059 23.2932C20.8333 23.6642 23.3335 21.4428 23.3335 18.6673C23.3335 18.4655 23.3195 18.2625 23.2927 18.0595C24.7312 17.2498 25.6668 15.7098 25.6668 14.0007C25.6668 12.2915 24.7312 10.7515 23.2927 9.94182ZM12.781 19.1527L8.50283 14.8197L10.1642 13.1817L12.7973 15.8487L17.8455 10.839L19.4882 12.4957L12.781 19.1527Z" fill="#111827"/>
</svg>
`;
const free_shipping_icon = `
<svg class="ab-svg" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.547363 5.24606C0.547363 4.13073 1.45153 3.22656 2.56686 3.22656H16.0337C17.149 3.22656 18.0544 4.13073 18.0544 5.24606V7.2679H20.187C20.9016 7.26692 21.5873 7.54976 22.0934 8.05423L25.3472 11.3069C25.8517 11.813 26.1345 12.4987 26.1335 13.2132V18.0409C26.4908 18.0409 26.8333 18.1828 27.0859 18.4354C27.3385 18.688 27.4804 19.0306 27.4804 19.3878C27.4804 19.745 27.3385 20.0876 27.0859 20.3402C26.8333 20.5928 26.4908 20.7347 26.1335 20.7347H24.7872C24.7618 21.7894 24.3251 22.7924 23.5701 23.5294C22.8152 24.2664 21.802 24.679 20.747 24.679C19.692 24.679 18.6788 24.2664 17.9239 23.5294C17.169 22.7924 16.7322 21.7894 16.7069 20.7347H11.3204C11.295 21.7894 10.8582 22.7924 10.1033 23.5294C9.3484 24.2664 8.33521 24.679 7.2802 24.679C6.22518 24.679 5.212 24.2664 4.45708 23.5294C3.70217 22.7924 3.26538 21.7894 3.24003 20.7347H2.56686C2.03115 20.7341 1.51761 20.5208 1.13913 20.1417C0.760654 19.7625 0.54822 19.2486 0.54853 18.7129L0.547363 5.24606ZM18.0544 13.9996H23.4409V13.2121L20.187 9.9594H18.0544V13.9996ZM7.2802 22.7531C7.81595 22.7531 8.32977 22.5402 8.70861 22.1614C9.08745 21.7826 9.30028 21.2687 9.30028 20.733C9.30028 20.1972 9.08745 19.6834 8.70861 19.3046C8.32977 18.9257 7.81595 18.7129 7.2802 18.7129C6.74444 18.7129 6.23062 18.9257 5.85178 19.3046C5.47294 19.6834 5.26011 20.1972 5.26011 20.733C5.26011 21.2687 5.47294 21.7826 5.85178 22.1614C6.23062 22.5402 6.74444 22.7531 7.2802 22.7531ZM22.7677 20.7324C22.7677 20.1966 22.5549 19.6828 22.176 19.304C21.7972 18.9251 21.2834 18.7123 20.7476 18.7123C20.2119 18.7123 19.698 18.9251 19.3192 19.304C18.9404 19.6828 18.7275 20.1966 18.7275 20.7324C18.7275 21.2682 18.9404 21.782 19.3192 22.1608C19.698 22.5396 20.2119 22.7525 20.7476 22.7525C21.2834 22.7525 21.7972 22.5396 22.176 22.1608C22.5549 21.782 22.7677 21.2682 22.7677 20.7324ZM11.3624 7.22356C11.1718 7.04116 10.9173 6.94064 10.6535 6.94354C10.3897 6.94643 10.1376 7.05251 9.95102 7.23905C9.76448 7.4256 9.6584 7.67777 9.6555 7.94157C9.65261 8.20536 9.75313 8.4598 9.93553 8.6504L11.577 10.2919H4.58753C4.45476 10.2916 4.32325 10.3175 4.20053 10.3682C4.07781 10.4188 3.96631 10.4932 3.87243 10.5871C3.77855 10.681 3.70414 10.7925 3.65348 10.9152C3.60281 11.0379 3.57689 11.1695 3.5772 11.3022C3.5772 11.8622 4.02753 12.3114 4.58753 12.3114H11.577L9.93553 13.9529C9.7625 14.1452 9.66986 14.3966 9.67669 14.6553C9.68353 14.9139 9.78932 15.1601 9.97226 15.343C10.1552 15.5259 10.4014 15.6317 10.66 15.6386C10.9186 15.6454 11.17 15.5528 11.3624 15.3797L14.7294 12.0127C14.8233 11.9193 14.8978 11.8082 14.9486 11.6859C14.9995 11.5635 15.0256 11.4324 15.0256 11.2999C15.0256 11.1674 14.9995 11.0362 14.9486 10.9139C14.8978 10.7916 14.8233 10.6805 14.7294 10.5871L11.3624 7.22356Z" fill="#111827"/>
</svg>
`;
const warning_icon = `
<svg class="ab-svg" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="5" cy="5" r="5" fill="#FF8127"/>
</svg>
`;

const common_style = `
<style>
    .rebuy-cart__flyout-installments {
        display: none !important;
    }
    .ab-svg {
        flex-shrink: 0;
    }
    .only-one-left {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-left: auto;
        font-weight: 800;
        font-size: 11px;
        line-height: 11px;
        color: #404040;
        margin-top: 8px;
    }
    .sale-badge {
        border-radius: 2px;
        padding: 4px 6px;
        background-color: #DC2626;
        color: #fff;
        font-weight: 700;
        font-size: 10px;
        line-height: 10px;
        text-transform: uppercase;
    }
    .bottom-usp-content {
        display: grid;
        grid-template-columns: auto 1fr auto;
        gap: 8px;
        margin: 24px auto 16px;
    }
    .bottom-usp-content-item {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .bottom-usp-content-item span {
        font-weight: 700;
        font-size: 14px;
        line-height: 14px;
        text-transform: capitalize;
        color: #111827;
    }
    .divider {
        width: 1px;
        height: 100%;
        background-color: #111827;
        margin: auto;
    }
    .rebuy-cart__flyout-item-price > div {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 4px;
    }
    .rebuy-cart__flyout-subtotal {
        display: grid;
        grid-template-columns: 1fr auto;
    }
    .cart-subtotal-discount {
        background-color:#2d5532;
        color: #fff;
        font-size: 12px;
        line-height: 12px;
        padding: 4px 6px;
        margin-left: auto;
        width: max-content;
        border-radius: 4px;
        margin-top: 4px;
        text-transform: uppercase;
        margin-bottom: 12px;
        grid-column: span 2;
    }
    .rebuy-cart__flyout-item-price {
        width: 100%;
        margin-top: 8px;
    }
    @media (max-width: 480px) {
        .bottom-usp-content-item span {
            font-size: 12px;
            line-height: 12px;
        }
    }
</style>
`;

const only_one_left_content_html = `
<div class="only-one-left">
    ${warning_icon}
    <span>Only a few left</span>
</div>
`;

const sale_badge_content_html = `
<span class="sale-badge">
    Sale
</span>
`;

const bottom_usp_content_html = `
<div class="bottom-usp-content">
    <div class="bottom-usp-content-item">
        ${verified_icon}
        <span>50K Happy Customers</span>
    </div>
    <div class="divider"></div>
    <div class="bottom-usp-content-item">
        ${free_shipping_icon}
        <span>Fast & Free Shipping</span>
    </div>
</div>
`;

const cart_subtotal_discount_html = (discounted_amount) => {
    return `
        <div class="cart-subtotal-discount">
            <span><span class="saveTitle">Save </span>${discounted_amount}</span>
        </div>
    `;
}

const inject_css = (head, style) => {
    try {
        head.insertAdjacentHTML('beforeend', style);
    } catch (error) {
        console.error('Inject css error', error);
    }
};

const bottom_usp_content = (item) => {
    try {
        item.insertAdjacentHTML('afterend', bottom_usp_content_html);
    } catch (error) {
        console.error('New elm content error', error);
    }
};

const check_is_mattress_link = (link) => {
    const base_url = window.location.origin;
    const updated_link = link.replace(base_url, '');
    const removed_query_params = updated_link.split('?')[0];
    const is_mattress_link = mattress_links.some(link => removed_query_params.includes(link));
    return is_mattress_link;
}

const cart_items_update = (items) => {
    try {
        items.forEach((item) => {
            const item_info = item.querySelector('.rebuy-cart__flyout-item-info');
            const quantity = item.querySelector('.rebuy-cart__flyout-item-quantity');
            if (item_info && quantity) {
                const item_price = item_info.querySelector('.rebuy-cart__flyout-item-price');
                const item_link = item_info.querySelector('a');
                if (check_is_mattress_link(item_link.href)) {
                    item_price.insertAdjacentHTML('afterend', only_one_left_content_html);
                }

                const is_compare_price = item_price.querySelector('.compare-at');
                if (is_compare_price) {
                    is_compare_price.insertAdjacentHTML('afterend', sale_badge_content_html);
                }
                if (quantity) {
                    quantity.insertAdjacentElement('beforebegin', item_price);
                    
                }
            }
        });
    } catch (error) {
        console.error('Cart items update error', error);
    }
};

const get_number_from_text = (text) => {
    return parseFloat(text.replace(/[^\d\-+\.]/g, ''));
}

const cart_subtotal_update = (subtotal) => {
    try {
        const final_amount = subtotal.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
        const compare_amount = subtotal.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');

        if (final_amount && compare_amount) {
            const final_amount_text = final_amount.querySelector('span:last-child').textContent.trim();
            const compare_amount_text = compare_amount.querySelector('span:last-child').textContent.trim();
            if (final_amount_text && compare_amount_text) {
                const final_amount_text_value = get_number_from_text(final_amount_text);
                const compare_amount_text_value = get_number_from_text(compare_amount_text);
                const discounted_amount = compare_amount_text_value - final_amount_text_value;
                const currency_symbol_from_text = final_amount_text.split('')[0];
                if (discounted_amount > 0) {
                    subtotal.closest('.rebuy-cart__flyout-subtotal').insertAdjacentHTML('beforeend', cart_subtotal_discount_html(`${currency_symbol_from_text}${discounted_amount.toFixed(2)}`));
                }
            }
        }
    } catch (error) {
        console.error('Cart subtotal update error', error);
    }
};

const cart_interval = setInterval(() => {
    try {
        const cart_cta = document.querySelector('.rebuy-cart__flyout-actions');
        const cart_items = document.querySelectorAll('.rebuy-cart__flyout-items li');
        const cart_subtotal = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
        const head = document.querySelector('head');
        const test_condition = head &&
            cart_cta && cart_items.length > 0 && !document.querySelector('.bottom-usp-content');
        if (test_condition) {
            inject_css(head, common_style);
            cart_items_update(cart_items);
            bottom_usp_content(cart_cta);
            cart_subtotal_update(cart_subtotal);
            clearInterval(cart_interval);
        }
    } catch (error) {
        console.error('A/B test js error', error);
    }
}, 10);